<template>
  <div class="navbar navbar-light py-0 fixed-top" :style="style">
    <a class="navbar-brand text-map" :href="sourcePath" target="_blank">
      {{name}}
    </a>
    <div class="float-right text-sm font-weight-bold text-map">
      <div>
        <span>{{distanceText}}</span>
        <span class="ml-2 mr-2">•</span>
        <span>{{elevationGainText}}</span>
        <span class="ml-2 mr-2">•</span>
        <span>{{elevationLossText}}</span>
      </div>
      <div class="d-none d-sm-block float-right">
        <span>{{elevationHighText}}</span>
        <span class="ml-2 mr-2">•</span>
        <span>{{elevationLowText}}</span>
      </div>
    </div>
  </div>
</template>

<script>
  import Polyglot from 'node-polyglot';

  import unitConversion from "../../utilities/unit_conversion";
  import translations from "../../translations/components/vector_map/map_header";

  export default {
    props: [
      'name',
      'sourcePath',
      'distance',
      'elevationGain',
      'elevationLoss',
      'elevationHigh',
      'elevationLow',
      'metric'
    ],

    data() {
      return {
        polyglot: new Polyglot({ phrases: translations.en })
      }
    },

    computed: {
      distanceText() {
        if (this.metric) {
          const units = this.polyglot.t('km');
          return `${unitConversion(this.distance, { from: 'm', to: 'km' }).toFixed(1)} ${units}`;
        }
        else {
          const units = this.polyglot.t('mi');
          return `${unitConversion(this.distance, { from: 'm', to: 'mi' }).toFixed(1)} ${units}`;
        }
      },

      elevationGainText() {
        return `${this.elevationText(this.elevationGain)} ${this.polyglot.t('gain')}`;
      },

      elevationLossText() {
        return `${this.elevationText(this.elevationLoss)} ${this.polyglot.t('loss')}`;
      },

      elevationHighText() {
        return `${this.elevationText(this.elevationHigh)} ${this.polyglot.t('high')}`;
      },

      elevationLowText() {
        return `${this.elevationText(this.elevationLow)} ${this.polyglot.t('low')}`;
      },

      style() {
        return {
          "background-color": "rgba(128, 128, 128, 0.2)"
        }
      }
    },

    methods: {
      elevationText(value) {

        if (this.metric) {
          const units = this.polyglot.t('m');
          return `${Math.round(value).toLocaleString()} ${units}`;
        } else {
          const units = this.polyglot.t('ft')
          const convertedValue = unitConversion(value, { from: 'm', to: 'ft' });
          return `${Math.round(convertedValue).toLocaleString()} ${units}`;
        }
      }
    }
  }
</script>
